
import { accounts } from './accounts';
import { navbar } from './navbar';
import { myCommunity } from './mycommunity';
import { profile } from './profile';
import { profits } from './profits';
import { sidebarAdmin } from './sidebar-admin';
import { sidebarUser } from './sidebar-user';
import { tutorials } from './tutorials';
import dashboard from './dashboard';
import { mobile } from './mobile';

export const backofficeIt ={
  ...accounts,
  ...navbar,
  ...myCommunity,
  ...profile,
  ...profits,
  ...sidebarAdmin,
  ...sidebarUser,
  ...tutorials,
  ...dashboard,
  ...mobile,
};
